import script from "./UserLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLogin.vue?vue&type=script&setup=true&lang=js"

import "./UserLogin.vue?vue&type=style&index=0&id=30bfc59c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30bfc59c"]])

export default __exports__